export default __webpack_public_path__ + "static/media/urology.6ca404e2.png";